import { render, staticRenderFns } from "./OrderInfoNotesDialog.vue?vue&type=template&id=9c266806&"
import script from "./OrderInfoNotesDialog.vue?vue&type=script&lang=ts&"
export * from "./OrderInfoNotesDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports